import type { SuiteResult } from '@k-ucap/shared';
import type { SuiteResultRepository } from './RepositoryInterfaces.js';

export class InMemorySuiteResultRepository implements SuiteResultRepository {
  private results: Map<string, SuiteResult> = new Map();

  async findAll(): Promise<SuiteResult[]> {
    return Array.from(this.results.values()).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  }

  async findById(id: string): Promise<SuiteResult | undefined> {
    return this.results.get(id);
  }

  async findBySuiteId(suiteId: string): Promise<SuiteResult[]> {
    return Array.from(this.results.values())
      .filter((r) => r.suiteId === suiteId)
      .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  }

  async findByRunId(runId: string): Promise<SuiteResult[]> {
    return Array.from(this.results.values())
      .filter((r) => r.runId === runId)
      .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  }

  async findByProjectId(projectId: string): Promise<SuiteResult[]> {
    return Array.from(this.results.values())
      .filter((r) => r.projectId === projectId)
      .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  }

  async save(result: SuiteResult): Promise<SuiteResult> {
    this.results.set(result.id, result);
    return result;
  }

  async delete(id: string): Promise<void> {
    this.results.delete(id);
  }

  seed(results: SuiteResult[]): void {
    results.forEach((r) => this.results.set(r.id, r));
  }
}

export const createInMemorySuiteResultRepository = (): InMemorySuiteResultRepository =>
  new InMemorySuiteResultRepository();
